/**
 * Adds or updates the spudId property in a Trumba embed code
 */
export function addOrUpdateTrumbaSpudId(
  embedCode: string,
  spudId: string
): string {
  // Check if id property already exists
  const hasId = /\$Trumba\.addSpud\(\s*\{[^}]*spudId\s*:/.test(embedCode)

  if (hasId) {
    // Update existing id property
    return embedCode.replace(
      /(\$Trumba\.addSpud\(\s*\{[^}]*spudId\s*:\s*)"[^"]*"([^}]*\}\s*\))/,
      `$1"${spudId}"$2`
    )
  } else {
    // Add new id property - find the closing part of the object and add before it
    return embedCode.replace(
      /(\$Trumba\.addSpud\(\s*\{[^}]*)(\}\s*\))/,
      `$1,\n   spudId: "${spudId}"$2`
    )
  }
}

export function updateTrumbaEventEmbed(
  embedCode: string
): string {
  const match = embedCode.match(/code:\s*"([^"]+)"/)
  const codeValue = match ? match[1] : null

  return `
    <script
      id="trumbaSubmitEventJS"
      type="text/javascript"
      src="//www.trumba.com/ea/scripts/submitevent.js"
    ></script>
    <script type="text/javascript">
      trumbaInsertSubmitEventForm({
        code: "${codeValue}",
        width: 502,
        height: 900,
        backgroundColor: "transparent"
      });
    </script>
  `
}

/**
 * Renders third-party embed code into the embedContainer element
 */
export function renderEmbedCode(
  embedCode: string,
  container: HTMLElement | null
) {
  if (!container) {
    console.error('Embed container element not accessible')
    return
  }
  container.innerHTML = ''

  // Create a temporary div to hold the embed code
  const tempDiv = document.createElement('div')
  tempDiv.innerHTML = embedCode

  // Append every child element (e.g. <iframe> tags) in the code to the container, except script tags, which are handled separately
  Array.from(tempDiv.children)
    .filter((child) => child.tagName !== 'SCRIPT')
    .forEach((child) => container.appendChild(child.cloneNode(true)))

  // Add a random ID to the container so scripts can hook onto the container element
  const randomId = `embed-${Math.random().toString(36).slice(2, 11)}`
  container.setAttribute('id', randomId)

  // Handle script tags individually (so that the scripts load when appended to the container element)
  const scripts = tempDiv.getElementsByTagName('script')
  Array.from(scripts).forEach((oldScript) => {
    const newScript = document.createElement('script')

    // Copy attributes from the old script to the new script
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value)
    })

    let oldHtml = oldScript.innerHTML

    // Trumba spud embed code
    if (oldHtml.includes('$Trumba.addSpud(')) {
      oldHtml = addOrUpdateTrumbaSpudId(oldHtml, randomId)
    }

    // Trumba event submit embed code
    if (oldHtml.includes('trumbaInsertSubmitEventForm(')) {
      const iframe = document.createElement('iframe')
      iframe.setAttribute('width', '100%')
      iframe.setAttribute('height', '1000px')
      iframe.setAttribute('scrolling', 'no')
      iframe.setAttribute('frameborder', '0')
      iframe.setAttribute('allowtransparency', 'true')
      iframe.setAttribute('title', 'Trumba Event Embed')
      iframe.classList.add('vssl-stripe--embed--trumba-event-form-submit')
      iframe.srcdoc = updateTrumbaEventEmbed(oldHtml)
      container.appendChild(iframe)
      return
    }

    // Append the new script to the container
    newScript.innerHTML = oldHtml
    container.appendChild(newScript)
  })
}
